import React from 'react';
import styled from 'styled-components';

export const H1 = ({ ...otherProps }) => {
  return <Heading1 {...otherProps} />;
};

export const H2 = ({ ...otherProps }) => {
  return <Heading2 {...otherProps} />;
};

export const H3 = ({ ...otherProps }) => {
  return <Heading3 {...otherProps} />;
};

export const H4 = ({ ...otherProps }) => {
  return <Heading4 {...otherProps} />;
};

export const H5 = ({ ...otherProps }) => {
  return <Heading5 {...otherProps} />;
};

export const H6 = ({ ...otherProps }) => {
  return <Heading6 {...otherProps} />;
};

export const Large = ({ ...otherProps }) => {
  return <TextLarge {...otherProps} />;
};

export const Medium = ({ ...otherProps }) => {
  return <TextMedium {...otherProps} />;
};

export const Normal = ({ ...otherProps }) => {
  return <TextNormal {...otherProps} />;
};

export const Small = ({ ...otherProps }) => {
  return <TextSmall {...otherProps} />;
};

export const Overline = ({ ...otherProps }) => {
  return <TextOver {...otherProps} />;
};

export const BtnLg = ({ ...otherProps }) => {
  return <TextButtonLarge {...otherProps} />;
};

export const BtnSm = ({ ...otherProps }) => {
  return <TextButtonSmall {...otherProps} />;
};

const Heading1 = styled.h1`
  font-family: Sofia Pro;
  font-size: 61px;
  font-weight: 600;
  line-height: 110%;
  letter-spacing: -0.05em;
  color: var(--neutral-7);
  padding: 0;
  margin: 0;
`;

const Heading2 = styled.h2`
  font-family: Sofia Pro;
  font-size: 49px;
  font-weight: 600;
  line-height: 110%;
  letter-spacing: -0.04em;
  color: var(--neutral-7);
  padding: 0;
  margin: 0;
`;

const Heading3 = styled.h3`
  font-family: Sofia Pro;
  font-size: 39px;
  font-weight: 600;
  line-height: 110%;
  letter-spacing: -0.04em;
  color: var(--neutral-7);
  padding: 0;
  margin: 0;
`;

const Heading4 = styled.h4`
  font-family: Sofia Pro;
  font-size: 31px;
  font-weight: 600;
  line-height: 110%;
  letter-spacing: -0.03em;
  color: var(--neutral-7);
  padding: 0;
  margin: 0;
`;

const Heading5 = styled.h5`
  font-family: Sofia Pro;
  font-size: 25px;
  font-weight: 600;
  line-height: 110%;
  letter-spacing: -0.02em;
  color: var(--neutral-7);
  padding: 0;
  margin: 0;
`;

const Heading6 = styled.h6`
  font-family: Sofia Pro;
  font-size: 20px;
  font-weight: 600;
  line-height: 110%;
  letter-spacing: -0.01em;
  color: var(--neutral-7);
  padding: 0;
  margin: 0;
`;

const TextLarge = styled.p`
  font-family: Sofia Pro;
  font-size: 25px;
  line-height: 150%;
  letter-spacing: -0.01em;
  color: var(--neutral-6);
  padding: 0;
  margin: 0;
`;

const TextMedium = styled.p`
  font-family: Sofia Pro;
  font-size: 20px;
  line-height: 150%;
  letter-spacing: -0.01em;
  color: var(--neutral-6);
  padding: 0;
  margin: 0;
`;

const TextNormal = styled.p`
  font-family: Sofia Pro;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: -0.01em;
  color: var(--neutral-6);
  padding: 0;
  margin: 0;
`;

const TextSmall = styled.p`
  font-family: Sofia Pro;
  font-size: 13px;
  line-height: 150%;
  letter-spacing: -0.01em;
  color: var(--neutral-6);
  padding: 0;
  margin: 0;
`;

const TextOver = styled.p`
  font-family: Sofia Pro;
  font-size: 16px;
  line-height: 110%;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--neutral-text-color);
  padding: 0;
  margin: 0;
`;

const TextButtonLarge = styled.p`
  font-family: Sofia Pro;
  font-size: 20px;
  line-height: 110%;
  letter-spacing: -0.01em;
  color: var(--neutral-7);
  padding: 0;
  margin: 0;
`;

const TextButtonSmall = styled.p`
  font-family: Sofia Pro;
  font-size: 16px;
  line-height: 110%;
  color: var(--neutral-7);
  padding: 0;
  margin: 0;
`;
